export const manageDevices = {
	solicitationTypes: {
		permanent: "Permanent",
		temporary: "Temporary",
	},
	deviceListByPlace: {
		title: "Equipment List by Place",
		totalDevices: "Total equipment",
		table: {
			emptyState: {
				title: "Nothing here yet",
			},
			columns: {
				contractStatus: "Contract status",
				contractId: "Contract ID",
				quantity: "Quantity",
				requestType: "Request type",
				serialNumber: "Serial Number",
				equipmentModel: "Model",
			},
		},
		filters: {
			byContractId: "Filter by contract ID",
			bySerialNumber: "Filter by serial number",
			byModel: "Filter by model",
			byStatus: "Filter by status",
		},
		btnExport: "Export",
		requestEquipments: "Request equipments",
		tag: {
			pendingSignature: "Pending signature",
			signatureExpired: "Signature expired",
			contractExpired: "Contract expired",
			active: "Contract active",
			closed: "Contract closed",
		},
	},
};
